import axios from 'axios'
import qs from 'qs'
import CryptoJS from 'crypto-js/crypto-js'

export function get(url, params){
  return new Promise((resolve, reject) =>{
      axios.get(url, {
          params: params
      }).then(res => {
          resolve(res.data);
      }).catch(err =>{
          reject(err)
      })
  });
}

export function post(url, params) {
  return new Promise((resolve, reject) => {
      let jsona = JSON.parse(JSON.stringify(params));
       axios.post(url, jsona)
      .then(res => {
          resolve(res.data);
      })
      .catch(err =>{
          reject(err)
      })
  });
}


export function hasObj(objArr, obj, oname) {
  let returnValue = false;
  for(let i = 0; i < objArr.length; i++ ) {
    if (objArr[i][oname] == obj[oname]) {
      returnValue = true;
      break;
    }
  }
  return returnValue;
}

export function getHasObjIndex(objArr, obj, oname) {
  let returnIndex = -1;
  for(let i = 0; i < objArr.length; i++) {
    if (objArr[i][oname] == obj[oname]) {
      returnIndex = i;
      break;
    }
  }
  return returnIndex;
}

export function updateData(objArr, sobj, attr) {
  objArr.forEach((element, index) => {
    if (element[attr] == sobj[attr]) {
      Object.assign(element, sobj);
    }
  });

  return objArr;
}

export function clearData(objArr, sobj, attr) {
  let oIndex = getHasObjIndex(objArr, sobj, attr);
  if (oIndex >= 0) {
    objArr.splice(oIndex, 1);
  }
  return objArr;
}

export function dealPersonData(objArr, attr) {
  let re = [];
  if ((typeof attr).toString().toLowerCase() === 'string') {
    objArr.forEach((obj, index) => {
      if(!!obj[attr]) {
        re.push(obj[attr])
      }
    })
  } else {
    objArr.forEach((obj, index) => {
      let temp = {};
      attr.forEach((sattr, index) => {
        if (!!obj[sattr]) {
          temp[sattr] = obj[sattr];
        }
      })
      if (obj.subject) {
        temp.subjects = obj.subject;
      }
      if (obj.soptionsArr.length == 4) {
        temp.optionA = obj.soptionsArr[0];
        temp.optionB = obj.soptionsArr[1];
        temp.optionC = obj.soptionsArr[2];
        temp.optionD = obj.soptionsArr[3];
      }
      re.push(temp);
    })
  }
  return re;
}

export function strToArrAndValidator(objArr) {
  let robj = [];
  let objsplit = objArr.split(',');
  objsplit.forEach(ele => {
    if (!!ele.trim()) {
      robj.push(ele.trim());
    }
  })
  return robj;
}

// 登录解密
export function decode() {

}

/**
 * AES 解密 ：字符串 key iv  返回base64
 *
 */
export function decrypt(word) {
  word = word.replace(/\s*/g,"");
  const key = CryptoJS.enc.Utf8.parse("20120401")
  let decrypt = CryptoJS.DES.decrypt({
    ciphertext: CryptoJS.enc.Base64.parse(word)
  }, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  let decryptedStr = CryptoJS.enc.Utf8.stringify(decrypt);
  console.log(decryptedStr)
  return decryptedStr;
}
export function encrypt(message) {
  var keyHex = CryptoJS.enc.Utf8.parse('20120401');
  var encrypted = CryptoJS.DES.encrypt(JSON.stringify(message), keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
}



// WEBPACK FOOTER //
// ./src/libs/tools.js